import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { Venue, Coords, CUSTOM_LOCATION_KEY } from '../../models';
import { VenueService } from '../../providers';
import { PlaceResult } from '../geo-search/geo-search.service';

@Component({
    selector: 'venue-creator',
    templateUrl: './venue-creator.component.html',
    styleUrls: ['./venue-creator.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class VenueCreatorComponent implements OnInit {

    @Input() proximityCoords: Coords = null;
    @Input() initVenueKey: string = CUSTOM_LOCATION_KEY;
    @Output() venueSelected = new EventEmitter<Venue>();

    // Venue to be created or edited
    public venue: Venue = null;
    public showEditor: boolean = false;
    public initAddress = '';

    public originVenueJson: string = '';

    // Expose to view
    public CUSTOM_LOCATION_KEY = CUSTOM_LOCATION_KEY;

    constructor(private venueService: VenueService) {
    }

    ngOnInit(): void {
    }

    /**
     * Set selected venue to be edited
     */
    public selectVenue(ev: Venue[]) {
        if(ev.length <= 0) {
            this.venue = null;
            return;
        }
        this.setVenue(ev[0]);
    }

    /**
     * Create a new venue (with coords from mote / custom position)
     */
    public createCustomVenue(venue: Venue) {
        let createVenue = new Venue(venue.toJson());
        createVenue.title = '';
        this.setVenue(createVenue);
        this.showEditor = true;
    }

    /**
     * Edit a new venue
     */
    public createVenue(venue: Venue) {
        this.setVenue(venue);
        this.showEditor = true;
    }

    /**
     * Set venue in member var, save origin for reset and set initial address 
     */
    public setVenue(venue: Venue) {
        // Set selected venue for edit
        this.venue = venue;
        this.initAddress = this.venue.address;
        this.updateVenueJson();
        this.venueSelected.emit(this.venue);
    }

    /**
     * Serialize selected venue and save the original json to be able to reset edit on cancel
     */
    private updateVenueJson() {
        if(!this.venue) return;
        // Serialize venue (for later reset)
        this.originVenueJson = JSON.stringify(this.venue.toJson());
    }

    /**
     * Show simple-select popup to edit currently selected venue
     */
    public editVenue() {
        this.showEditor = true;
    }

    /**
     * Delete venue from database
     */
    public async deleteVenue() {
        if(!this.venue) return;

        let ok = await confirm("Delete this venue? (you can not go back)");
        if(!ok) return;

        this.venueService.deleteVenue(this.venue.key);
        this.venue = null;
        this.initVenueKey = CUSTOM_LOCATION_KEY;
    }

    /**
     * Reset changes made in venue
     */
    public resetVenue() {
        this.showEditor = false;
        if(!this.venue || !this.originVenueJson) return;
        // Reset venue with original json
        this.venue.fromJson(JSON.parse(this.originVenueJson));
    }

    /**
     * Save venue to database
     */
    public saveVenue(venue: Venue) {
        if(!venue) return;
        // Create a new key if this venue was created from custom location
        if(!venue.key || venue.key == CUSTOM_LOCATION_KEY) venue.key = venue.genKey();
        this.showEditor = false;
        this.venueService.saveVenue(venue);
        this.initVenueKey = venue.key;
        // Update json for reset (if reopened)
        this.updateVenueJson();
    }

    /**
     * Extract position for venue when a geo position is selected from list
     */
    public geoPositionSelected(feature: PlaceResult) {
        // Reset coords if no feature selected
        if(!feature || feature.position) {
            return;
        }

        // this.geoCoords = new Coords(position[1], position[0], true);
        if(!this.venue) return;

        this.venue.lat = feature.position.lat;
        this.venue.long = feature.position.long;
        this.venue.address = feature.name;
    }
}
